<template>
    <a-modal title="积分详情" width="100%"  class="full-modals" :visible="visible" centered :destroy-on-close="true" :mask-closable="false" :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" wrap-class-name="single-spa-vue" footer=''>
        
        <div class="flex" style="width:68%;margin:0 auto;
        margin-top: 0px;">
            <div style="width:80%;height:200px;margin-top:40px;text-align:center; line-height:25px; position:relative">
                <div style="width:260px; margin-left:20px; position:relative">
                    <img style="width:220px" src="../../../../assets/img/dataShow.png" alt="">
                    <div style="position:absolute;top:10px;left:30px">
                        <h1 style="font-weight:600;font-size:100px;color:#9e5400" v-for="item in score.data" :key="item">
                            {{ item }}
                        </h1>
                    </div>
                    <div style="width:240px; text-align:left; top:18px; left:250px; font-size:16px; line-height:40px; position:absolute">
                        <p v-if="score.zb[0]">{{score.zb[0].name}}：{{score.zb[0].value}}</p>
                        <p v-if="score.zb[1]">{{score.zb[1].name}}：{{score.zb[1].value}}</p>
                        <p v-if="score.zb[2]">{{score.zb[2].name}}：{{score.zb[2].value}}</p>
                    </div>
                </div>
            </div>
            <div style="flex:1;position:relative">
                <div v-if="score.zb[2]">
                <a-progress v-if="score.zb[2]" class="progreesA" strokeColor="#f2c5ff" stroke-linecap="square" type="circle" :percent="(score.zb[2].value/20*100).toFixed(0)" :width="80" :strokeWidth="20" @mouseover="progreesDVlue='2'" @mouseleave="progreesDVlue='3'"/>
                <a-progress class="progreesB" strokeColor="#ffbc85" stroke-linecap="square" type="circle" :percent="(score.zb[1].value/50*100).toFixed(0)" :width="140" :strokeWidth="15" @mouseover="progreesDVlue='1'" @mouseleave="progreesDVlue='3'"/>
                <a-progress class="progreesC" strokeColor="#85c4ff" stroke-linecap="square" type="circle" :percent="(score.zb[0].value/50*100).toFixed(0)" :width="200"  :strokeWidth="12" @mouseover="progreesDVlue='0'" @mouseleave="progreesDVlue='3'"/>
                </div>
                <div v-else>
                    <a-progress v-if="score.zb[2]" class="progreesA" strokeColor="#f2c5ff" stroke-linecap="square" type="circle" :percent="(score.zb[2].value/20*100).toFixed(0)" :width="80" :strokeWidth="20" @mouseover="progreesDVlue='2'" @mouseleave="progreesDVlue='3'"/>
                    <a-progress class="progreesB" strokeColor="#ffbc85" stroke-linecap="square" type="circle" :percent="(score.zb[1].value/20*100).toFixed(0)" :width="140" :strokeWidth="15" @mouseover="progreesDVlue='1'" @mouseleave="progreesDVlue='3'"/>
                    <a-progress class="progreesC" strokeColor="#85c4ff" stroke-linecap="square" type="circle" :percent="(score.zb[0].value/100*100).toFixed(0)" :width="200"  :strokeWidth="12" @mouseover="progreesDVlue='0'" @mouseleave="progreesDVlue='3'"/>
                    </div>
                <div v-if="score.zb[2]">
                    <div v-if="progreesDVlue=='2'" class="progreesD" >{{score.zb[2].value}}</div>
                    <div v-if="progreesDVlue=='1'" class="progreesD" >{{score.zb[1].value}}</div>
                    <div v-if="progreesDVlue=='0'" class="progreesD" >{{score.zb[0].value}}</div>
                    <div v-if="progreesDVlue=='3'" class="progreesD" >{{score.data['总分']}}</div>
                </div>
                <div v-else>
                    <div v-if="progreesDVlue=='2'" class="progreesE" >{{score.zb[2].value}}</div>
                    <div v-if="progreesDVlue=='1'" class="progreesE" >{{score.zb[1].value}}</div>
                    <div v-if="progreesDVlue=='0'" class="progreesE" >{{score.zb[0].value}}</div>
                    <div v-if="progreesDVlue=='3'" class="progreesE" >{{score.data['总分']}}</div>
                </div>
                <div class="scoreVle" v-if="progreesDVlue=='2'">{{score.zb[2].name}}</div>
                <div class="scoreVle" v-if="progreesDVlue=='1'">{{score.zb[1].name}}</div>
                <div class="scoreVle" v-if="progreesDVlue=='0'">{{score.zb[0].name}}</div>
                <div class="scoreVle" v-if="progreesDVlue=='3'">总得分</div>
            </div>
            <!-- {{ getType}} -->
            <!-- <RadarEcharts  style="top:60px;width:60%;right:10%" v-if="showData&&score.zb[2]" :getType="getType" :chartData="chartData"></RadarEcharts> -->
        </div>
        <div style="width:80%;margin: -40px auto 0;">
            <a-divider style="width:80%;"/>
        </div>
        <div style="width:80%;margin:0 auto;position:relative">
            
            <table class="tableClass">
                <tbody v-if="score.zb[0]">
                    <div class="echartRadar">
                        <RadarEchartsBody style="position:absolute;top:60px;width:55%;right:0%" v-if="showData" :getType="getType" :chartData="chartData0"></RadarEchartsBody>
                    </div>
                <tr>
                    <th colspan=2 style="background: #ebf1ff;">{{score.zb[0].name}}
                    </th>
                </tr>
                <tr v-for="(item,index,on) in score.zb[0].data" :key="index">
                    <td><i>{{on+1}}</i>{{ index }} ：</td>
                    <td><span>{{ item }}</span></td>
                </tr>
                </tbody>
                <!-- <tr v-for="(item,index) in score" :key="index">
                    <td>{{ index }}</td>
                    <td>{{ item }}</td>
                </tr> -->
                <tbody v-if="score.zb[1]">
                    <div class="echartRadar">
                    <RadarEchartsBody2 style="position:absolute;top:60px;width:55%;right:0%" v-if="showData" :getType="getType" :chartData="chartData1"></RadarEchartsBody2>
                    </div>
                <tr>
                    <th colspan=2 style="background: #f4ede5;">{{score.zb[1].name}}
                    </th>
                </tr>
                <tr v-for="(item,index,on) in score.zb[1].data" :key="index">
                    <td><i>{{on+1}}</i>{{ index }} ：</td>
                    <td><span>{{ item }}</span></td>
                </tr>
                </tbody>
                <tbody v-if="score.zb[2]">
                    <div class="echartRadar">
                    <RadarEchartsBody1 style="position:absolute;top:60px;width:55%;right:0%" v-if="showData" :getType="getType" :chartData="chartData2"></RadarEchartsBody1>
                    </div>
                <tr>
                    <th colspan=2 style="background: #eee6f5;">{{score.zb[2].name}}
                    </th>
                </tr>
                <tr v-for="(item,index,on) in score.zb[2].data" :key="index">
                    <td><i>{{on+1}}</i>{{ index }} ：</td>
                    <td><span>{{ item }}</span></td>
                </tr>
                </tbody>
                <!-- <tr>
                    <th>总分</th>
                </tr>
                <tr v-for="(item,index) in score.data" :key="index">
                    <td>{{ index }}:<span>{{ item }}</span></td>
                </tr> -->
            </table>
        </div>
    </a-modal>
</template>

<script>
// import RadarEcharts from "./randeChart";
import RadarEchartsBody from "./randeChartBody";
import RadarEchartsBody1 from "./randeChartBody1";
import RadarEchartsBody2 from "./randeChartBody2";
import {
    formMixin,tableListMixin
} from "@/mixins";

export default {
    name: "AddOrEditModal",
    props: ["scoreData","getType"],
    mixins: [formMixin,tableListMixin],
    components: {
        // RadarEcharts,
        RadarEchartsBody,RadarEchartsBody1,RadarEchartsBody2},
    data() {
        return {
            progreesDVlue:'3',
            score:[
                {
                    name:"技术创新指标(50分)",
                    value:null 
                },
                {
                    name:"成长经营指标(50分)",
                    value:null 
                },
                {
                    name:"辅助指标-正向指标(20分)",
                    value:null 
                },
            ],
            chartData: null,
            chartData0: null,
            chartData1: null,
            chartData2: null,
            showData: false
        }
    },
    watch:{
        scoreData(val){
            this.showData = false
            this.chartData = val.zb
            this.chartData0 = val.zb[0]
            this.chartData1 = val.zb[1]
            this.chartData2 = val.zb[2]
            this.score = val
            console.log('积分',this.score)
            this.$nextTick(() => {
                this.showData = true
            })

        }
    },
    methods: {
        
    },
    created(){
    }
}
</script>

<style>

.full-modals .ant-modal-content{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 97vh;
}
.full-modals  .ant-modal-content .ant-modal-body{
    max-height: 95vh;
}
</style>
<style scoped lang="less">

tbody{
    position: relative;
}
.echartRadar{
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height:100%;
    min-height:400px;
    justify-content: right;
    width: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.progreesA{
position:absolute;left:60px;top:60px;z-index:8;cursor: pointer;
}
.progreesB{
    position:absolute;left:30px;top:30px;z-index:7;cursor: pointer;
}
.progreesC{
    position:absolute;left:0;top:0;z-index:6;cursor: pointer;
}
.progreesD{
    position:absolute;left:75px;z-index:9; top:75px;background: #fff;width:50px;height:50px;border-radius: 140px;
    line-height: 50px;
    font-size: 35px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
}
.progreesE{
    position:absolute;left:60px;z-index:9; top:60px;background: #FFF;width:80px;height:80px;border-radius: 140px;
    line-height: 80px;
    font-size: 35px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;

}
.scoreVle{
    position: absolute;
    right: -43px;
    background: #fff;
    top: 200px;
    height: 30px;
    text-align: center;
    z-index: 9;
    bottom: 75px;
}
.tableClass{
    td{
        span{
            font-size: 20px;
            vertical-align: middle;
            margin-left: 5px;
        }
        i{
            font-style: normal;
            border-radius: 30px;
            padding:0px 3.5px 0px 3px;
            text-align: center;
            margin-right: 5px;
            font-size: 12px;
            border: 1px solid #000000;
        }
        padding: 10px 0;
        text-align: left;
    }
    td:nth-child(odd){
        width:420px;
        text-align: left;
    }
    th{
        background: #faecff;
        font-size: 16px;
        padding:10px 20px;
        position: relative;
    }
}
</style>
